import {View} from 'MWC';
import tpl from '../templates/UsageBlock.jsx';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);
        this.state = {
            ui: this.uiStates.INITIAL,
            showModal: false
        };
        return this;
    }

    static defaultProps = {
        title: 'Put your title here',
        id: ''
    };
}
